import { Switch } from "antd";
import React, { useState } from "react";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import { IoMdNotificationsOutline } from "react-icons/io";
import { TbSettingsCog } from "react-icons/tb";

function Settings() {
  const [activeStep, setActiveStep] = useState(1);
  const onChange = (checked) => {};

  return (
    <div className="my_account settings">
      <div className="tabs_area">
        <div className="steps">
          <button
            className={`step ${activeStep === 1 ? "active" : ""}`}
            onClick={() => setActiveStep(1)}
            disabled={false}
            aria-label="Step 1: Documents"
          >
            <TbSettingsCog className="icons" /> Account Settings
          </button>
          <button
            className={`step ${activeStep === 2 ? "active" : ""}`}
            onClick={() => setActiveStep(2)}
            disabled={false}
            aria-label="Step 2: Refer a Friend"
          >
            <IoMdNotificationsOutline className="icons" /> Notifications
          </button>
        </div>
        <div className="step-container">
          <div className="step-content">
            {activeStep === 1 && (
              <>
                <div className="tabs_card">
                  <div className="header">
                    <h4>Personal Information</h4>
                    <HiOutlinePencilSquare className="icons" />
                  </div>
                  <div className="content">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="info">
                          <label htmlFor="">Name</label>
                          <h4>Adam Smith</h4>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="info">
                          <label htmlFor="">Email</label>
                          <h4>example@gmail.com</h4>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="info">
                          <label htmlFor="">Phone Number</label>
                          <h4>888-888-8888</h4>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="info">
                          <label htmlFor="">Address</label>
                          <h4>123 Main Street Atlanta, GA, 30033</h4>
                        </div>
                      </div>
                    </div>
                    <button className="btn mt-4">Change Password</button>
                  </div>
                </div>
              </>
            )}
            {activeStep === 2 && (
              <div className="tabs_card">
                <div className="header">
                  <h4>Notification Settings</h4>
                  <HiOutlinePencilSquare className="icons" />
                </div>
                <div className="content">
                  <div className="notify_info">
                    <p>Email Notifications</p>
                    <Switch defaultChecked onChange={onChange} />
                  </div> 
                  <hr/>
                  <div className="notify_info">
                    <p>Email Notifications</p>
                    <Switch defaultChecked onChange={onChange} />
                  </div> 
                  <hr/>
                  <div className="notify_info">
                    <p>Email Notifications</p>
                    <Switch defaultChecked onChange={onChange} />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings;
